// extracted by mini-css-extract-plugin
export default {"head":"Doc_head__zrB9N","main":"Doc_main__f4PsS","textarea":"Doc_textarea__c+IfM"};